import React from 'react';
import { BOOK_DEMO_URL, Cta, GET_STARTED_URL, IMG, Sparkle } from './shared';

const HERO_IMAGE = {
  src: `${IMG}/inshurlp-couple-hero.png`,
  alt: 'A smiling couple holding up a car key in a sunny dealership lot with a row of rental cars behind them',
  position: '78% center',
};

/** Two-column hero: partnership pitch on the left, single image right. */
const Hero = () => (
    <section className="ilp-hero">
      <div className="ilp-hero-grid">
        <div className="ilp-hero-copy">
          <p className="ilp-hero-eyebrow">Rentid &amp; INSHUR Partnership</p>

          <h1 className="ilp-hero-title">Rental platform, and your insurance policy, all in one place.</h1>

          <p className="ilp-hero-sub">
            Access everything you need to manage your rental business with greater control, including
            bookings, insurance, verification, fleet management, payments, agreements, and more.
          </p>

          <div className="ilp-cta-row ilp-hero-ctas">
            <Cta href={GET_STARTED_URL} label="Get Started" />
            <Cta href={BOOK_DEMO_URL} label="Book Demo" tone="dark" />
          </div>

          <p className="ilp-hero-microcopy ilp-microcopy">
            <span>Start for Free</span>
            <Sparkle />
            <span>Only pay when rented</span>
            <Sparkle />
            <span>Subscribe &amp; Save</span>
          </p>

          <p className="ilp-hero-poweredby">
            <img src={`${IMG}/rentid-logo-black.png`} alt="Rentid" className="ilp-hero-logo-rentid" />
            <span className="ilp-hero-logo-x">x</span>
            <img src={`${IMG}/inshur-logo-blue.svg`} alt="INSHUR" className="ilp-hero-logo-inshur" />
            <span className="ilp-hero-poweredby-text">
              have partnered to empower rental businesses across the US.
            </span>
          </p>
        </div>

        <div className="ilp-hero-media">
          <div className="ilp-hero-frame-wrap">
            <img
              src={`${IMG}/hatched-circle-purple.png`}
              alt=""
              aria-hidden="true"
              className="ilp-hero-circle ilp-hero-circle--purple"
            />
            <img
              src={`${IMG}/hatched-circle-yellow.png`}
              alt=""
              aria-hidden="true"
              className="ilp-hero-circle ilp-hero-circle--yellow"
            />

            <div className="ilp-hero-frame">
              <img
                src={HERO_IMAGE.src}
                alt={HERO_IMAGE.alt}
                className="ilp-hero-img"
                style={{ objectPosition: HERO_IMAGE.position }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
);

export default Hero;
